import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, makeStyles} from "@material-ui/core";
import {LcmDialogProps} from "./DialogProps";
import {updateLcmStatus} from "../../../redux/actions";
import {useDispatch} from "react-redux";
import {LcmStatus} from "../../../domain/LcmModel";

const useStyles = makeStyles(() => ({
    actions: {
        padding: 15,
    },
}));

export const ReopenCaseDialog: React.FC<LcmDialogProps> = ({
    lcmItem,
    onClose,
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const onSubmit = () => {
        dispatch(updateLcmStatus(lcmItem.id, LcmStatus.Open, "Case re-opened"));
        onClose();
    };

    return (
        <Dialog
            open={true}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            data-test="close-case-dialog"
        >
            <DialogTitle data-test="activity-title">Re-open case</DialogTitle>
            <Divider component="div" />
            <DialogContent>
                <form>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            Are you sure you want to re-open this LCM?
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button
                    onClick={onClose}
                    color="primary"
                    data-test="return-close-case-button"
                >
                    Cancel
                </Button>
                <Button
                    onClick={onSubmit}
                    color="primary"
                    data-test="continue-close-case-button"
                >
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
};
